import script from "./Qinfo.vue?vue&type=script&setup=true&lang=js"
export * from "./Qinfo.vue?vue&type=script&setup=true&lang=js"

import "./Qinfo.vue?vue&type=style&index=0&id=6ab45ee6&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ab45ee6"]])

export default __exports__